import React from 'react';
import Modal from '../../commonComponents/util/Modal';
import ValidatedInput from '../../commonComponents/util/ValidatedInput';
import AutoSuggestInput from '../../commonComponents/util/AutoSuggestInput';
import LoadingSpinner from '../../commonComponents/util/LoadingSpinner';
import FadeOutErrorMessage from '../../commonComponents/util/FadeOutErrorMessage';

export default class SelectExternalParticipantModal extends React.Component {

    constructor(props) {
        super(props);

        const state = {
            isReceiving: true,
            recipientId: "",
            submitAttempted: false
        };

        this.state = {
            ...state,
            initialState: { ...state }
        };
    }

    onCreate = () => {
        this.props.showCreate();
        this.setState(this.state.initialState);
    }

    onChange = (name, value) => {
        this.setState({ [name]: value });
    };

    onClose = () => {
        this.props.close();
        this.setState(this.state.initialState);
    }

    onSubmit = async () => {
        this.setState({ submitAttempted: true });

        const { isReceiving, recipientId } = this.state;

        if (!recipientId) {
            return;
        }

        await this.props.submit({ recipientId, isReceiving });

        if (this.props.success) {
            this.onClose();
        }
    }

    render() {
        const {
            recipientId,
            isReceiving,
            submitAttempted
        } = this.state;

        const {
            clearRecipientSuggestions,
            getRecipientSuggestions,
            listRecipients,
            loading,
            recipientSuggestions,
            show,
            success
        } = this.props;

        return (
            <Modal modalShowing={show}>
                <div className="modal-container">
                    <div className="modal external-participant-modal">
                        <div className="modal-header">
                            <h4 className="page-header">
                                Add Participant
                            </h4>
                            <i className="icon ion-ios-close-empty" onClick={this.onClose}></i>
                        </div>

                        <div className="modal-section">
                            <div className="modal-row flex-center">
                                <div className="search-input-container">
                                    <ValidatedInput
                                        input={
                                            <AutoSuggestInput
                                                allowIncomplete={false}
                                                disabled={listRecipients.loading || !listRecipients.success}
                                                suggestions={recipientSuggestions.data}
                                                suggestionKey="applicantId"
                                                suggestionValue="name"
                                                getSuggestions={getRecipientSuggestions}
                                                clearSuggestions={clearRecipientSuggestions}
                                                loadingSuggestions={recipientSuggestions.loading}
                                                update={(name, { applicantId }) => this.onChange(name, applicantId)}
                                            />
                                        }
                                        label="Select Recipient"
                                        name="recipientId"
                                        value={recipientId}
                                        required={true}
                                        showRequiredError={submitAttempted}
                                    />
                                </div>
                                <div>
                                    <button
                                        className="btn btn-accent2"
                                        disabled={loading}
                                        onClick={this.onCreate}
                                    >
                                        <i className="icon ion-ios-plus-empty icon-left"></i>
                                        Create
                                    </button>
                                </div>
                            </div>
                            {
                                !loading && (
                                    listRecipients.loading
                                        ? <span className="small-text accent-text">
                                            Retrieving recipient suggestion information for your campaign list, please wait...
                                            </span>
                                        : (!listRecipients.success
                                            && <span className="small-text error-text">
                                                Something went wrong when attempting to retrieve recipient suggestion information for your campaign list.  Please try refreshing the page.
                                                </span>
                                        )
                                )
                            }
                        </div>

                        <div className="modal-section">
                            <div className="custom-check-container">
                                <input
                                    type="checkbox"
                                    id="isReceiving"
                                    className="custom-check input"
                                    name="isReceiving"
                                    checked={isReceiving}
                                    onChange={e => this.onChange(e.target.name, e.target.checked)}
                                />
                                <label htmlFor="isReceiving" className="secondary-text input">
                                    Is Receiving
                                </label>
                            </div>
                        </div>
                        {loading
                            ? <LoadingSpinner height="20" alignRight={true} />
                            : <div className="modal-btns text-right">
                                <button
                                    className="btn btn-accent"
                                    onClick={this.onClose}
                                >
                                    Cancel
                                </button>
                                <button
                                    className="btn btn-primary"
                                    onClick={this.onSubmit}
                                    disabled={!recipientId}
                                >
                                    Submit
                                </button>
                                <FadeOutErrorMessage show={!loading && !success} />
                            </div>}
                    </div>
                </div>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/campaignComponents/externalLists/SelectExternalParticipantModal.jsx